var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",class:_vm.hasBg ? 'background-gray' : '',attrs:{"id":"app"}},[(_vm.isNotAuthRoute)?_c('layout-sidebar'):_vm._e(),_c('div',{staticClass:"w-full overflow-hidden",class:_vm.isNotAuthRoute ? 'layout-responsive' : 'layout-responsive-auth'},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }